import script from "./AddBankCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddBankCard.vue?vue&type=script&lang=ts&setup=true"

import "./AddBankCard.vue?vue&type=style&index=0&id=29571e9a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29571e9a"]])

export default __exports__